import React, { useEffect, useState } from "react";
import "../css/Navbar.css"; // For styling
import BioDialogBox from "./BioDialogBox";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../redux/slices/LoginSlice"; // Adjust the path to match your file structure
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress, Snackbar, Alert } from "@mui/material";
import Button from "@mui/material/Button";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { store } from "../redux/store";

const Navbar = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const { profileDetails, profileDetailsLoading } = useSelector(
    (state) => state.ProfileSlice
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loadingLogout ,loadingLogoutSuccess} = useSelector((state) => state.LoginSlice);

  const openDialog = () => {
    setDialogOpen(true);
  };

  const closeDialog = () => {
    setDialogOpen(false);
  };

  const closeSnackbar = () => {
    setSnackbarOpen(false);
  };

  const logout = async () => {
     dispatch(logoutUser());
    

  };

  useEffect(()=>{
    console.log('loadingLogoutSuccess',loadingLogoutSuccess)
    if(loadingLogoutSuccess){
      store.dispatch({ type: "auth/clearState" }); // Clear entire Redux state
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      setSnackbarOpen(true); // Open the snackbar after logout
      setTimeout(() => {
        navigate("/"); // Navigate on successful login after showing the snackbar
      }, 1500); // Adjust delay as needed
    }
   
  },[loadingLogoutSuccess])

  return (
    <nav className="navbar">
      <div onClick={()=>navigate('/agentSelection')} className="navbar-left">
        <img
          src={require("../assets/images/logo.png")}
          alt="Logo"
          className="navbar-logo"
        />
        <h1 className="navbar-title">AgentX</h1>
      </div>
      <div className="navbar-right">
        {/* <div style={{marginRight:50}}>
        <Button
      onClick={()=>navigate('/NewAgentViewerScreen')}
      variant="contained"
      color="primary"
     
      startIcon={
        <CheckCircleIcon />
      }
    
    >
      { "Check Status"}
    </Button>
        </div> */}
      
        <button
          style={{ backgroundColor: "transparent", border: "none" }}
          onClick={()=>logout()}
        >
          {loadingLogout ? (
            <CircularProgress size={24} sx={{ color: "blue" }} />
          ) : (
            <img
              src={require("../assets/images/logout.png")}
              alt="Logo"
              className="navbar-profile-logout"
            />
          )}
        </button>

        <img
         style={{width:35,height:35}}
          src={require("../assets/images/bell.png")}
          alt="Logo"
          className="navbar-profile"
        />
        <button
          style={{ backgroundColor: "transparent", border: "none" }}
          onClick={openDialog}
        >
          <img
            src={require("../assets/images/profile.png")}
            alt="Logo"
            className="navbar-profile"
          />
        </button>
        <label className="navbar-text">{profileDetails?.first_name+" "+profileDetails?.last_name}</label>
      </div>
      <BioDialogBox open={dialogOpen} onClose={closeDialog} />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={closeSnackbar} severity="success" sx={{ width: "100%" }}>
          Logout successful!
        </Alert>
      </Snackbar>
    </nav>
  );
};

export default Navbar;
